import { processData } from "../data/siteContent";
import useReveal from "../hooks/useReveal";

function Step({ step, index }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`process-step-${index}`}
      className="reveal relative pl-6 md:pl-0"
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <p className="font-serif text-5xl md:text-6xl text-brand-red font-light mb-5">
        {step.number}
      </p>
      <div className="h-px w-12 bg-brand-charcoal/30 mb-5" />
      <h3 className="font-serif text-xl md:text-2xl text-brand-charcoal mb-3 leading-snug">
        {step.title}
      </h3>
      <p className="text-sm text-neutral-600 leading-relaxed">{step.text}</p>
    </div>
  );
}

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32 bg-brand-grey"
    >
      <div className="container mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <p className="text-xs tracking-[0.35em] uppercase text-brand-red mb-5 font-medium">
            <span className="inline-block w-10 h-px bg-brand-red align-middle mr-4" />
            {processData.eyebrow}
          </p>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl text-brand-charcoal leading-[1.1] tracking-tight mb-6">
            {processData.title}
          </h2>
          <p className="text-base md:text-lg text-neutral-700 leading-relaxed">
            {processData.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {processData.steps.map((s, i) => (
            <Step key={s.number} step={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
